<app-navbar [title]="transport.name">
	<a class="btn btn-warning me-4" routerLink="../"> <i class="fas fa-map-marked-alt"></i> Mapa </a>
	<a class="btn btn-warning me-4" routerLink="../table"> <i class="fas fa-random"></i> Rozkład </a>
</app-navbar>

<div class="container mt-3">
	<div class="card mb-3">
		<div class="card-body">
			<h5 class="card-title">Kopiowanie do pustych transportów</h5>
			<p class="card-text">
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero molestias et sit dolorum rerum quasi!
				Itaque cum modi adipisci eaque reprehenderit incidunt, quidem ratione ullam consequuntur cumque
				laudantium iusto dolores.
			</p>
			<div class="btn btn-primary" (click)="copyAsk('simple')">Rozpocznij</div>
		</div>
	</div>

	<div class="card">
		<div class="card-body">
			<h5 class="card-title">Kopiowanie do wszystkich transportów</h5>
			<p class="card-text">
				Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum accusamus fugit dolor sit illo cum ex.
				Deleniti repudiandae ullam fugiat perspiciatis laborum assumenda eius iusto veniam quas, doloribus ea
				officiis.
			</p>
			<div class="btn btn-primary" (click)="copyAsk('full')">Rozpocznij</div>
		</div>
	</div>
</div>
